import { defineStore } from "pinia";

export const userStore = defineStore({
  id: "user",
  state: () => ({
    token: null,
    user: {
      id: null,
      username: null,
      email: null,
      name: null,
      is_email_verified: null,
      status: null,
      group_id: null,
      group_name: null,
      client_id: null,
      client_name: null,
      division_id: null,
      division_name: null,
    },
    permissions: null,
    view_alert_maintanance: false,
    two_factor_method: null,
  }),
  getters: {
    getId: (state) => state.user.id,
    getUsername: (state) => state.user.username,
    getGroupName: (state) => state.user.group_name,
    getEmail: (state) => state.user.email,
    getToken: (state) => state.token,
    getPermission: (state) => state.permissions,
    getName: (state) => state.user.name,
    getIsEmailVerified: (state) => state.user.is_email_verified,
    getClientId: (state) => state.user.client_id,
    getClientName: (state) => state.user.client_name,
    getDivisionId: (state) => state.user.division_id,
    getDivisionName: (state) => state.user.division_name,
    getViewAlertMaintanance: (state) => state.view_alert_maintanance,
    getTwoFactorMethod: (state) => state.two_factor_method,
  },
  actions: {
    setAllData(token, user, permissions) {
      this.token = token;
      this.user = user;
      this.permissions = permissions;
    },
    setIsEmailVerified(isEmailVerifiend) {
      this.user.is_email_verified = isEmailVerifiend;
    },
    setTwoFactorMethod(method) {
      this.two_factor_method = method;
    },
    hasPermission(permission) {
      if (this.permissions === null) {
        return false;
      }
      return this.permissions.includes(permission);
    },
    setViewAlertMaintanance(val) {
      this.view_alert_maintanance = val;
    },
  },
  persist: {
    storage: localStorage,
  },
});
